import {Injectable} from '@angular/core';
import {plainToClass} from 'class-transformer';

import {ButtonListQuestionType} from 'shared/models/questions/button-list-question-type';
import {EnergyLevelQuestionType} from 'shared/models/questions/energy-level-question-type';
import {MessageQuestionType} from 'shared/models/questions/message-question-type';
import {MultiSliderQuestionType} from 'shared/models/questions/multi-slider-question-type';
import {PerformanceLevelQuestionType} from 'shared/models/questions/performance-level-question-type';
import {QuestionType} from 'shared/models/questions/question-type';
import {RatingQuestionType} from 'shared/models/questions/rating-question-type';
import {SliderQuestionType} from 'shared/models/questions/slider-question-type';
import {YesNoQuestionType} from 'shared/models/questions/yes-no-question-type';

@Injectable()
export class QuestionTypeFactoryService {

  public createQuestionType(name: string, data?: QuestionType): QuestionType {
    data = data || <QuestionType> {};
    let questionType: QuestionType;

    if (name === 'buttonList') {
      questionType = plainToClass(ButtonListQuestionType, data);
    } else if (name === 'slider') {
      questionType = plainToClass(SliderQuestionType, data);
    } else if (name === 'rating') {
      questionType = plainToClass(RatingQuestionType, data);
    } else if (name === 'energylevel') {
      questionType = plainToClass(EnergyLevelQuestionType, data);
    } else if (name === 'message') {
      questionType = plainToClass(MessageQuestionType, data);
    } else if (name === 'multislider') {
      questionType = plainToClass(MultiSliderQuestionType, data);
    } else if (name === 'performancelevel') {
      questionType = plainToClass(PerformanceLevelQuestionType, data);
    } else if (name === 'yesno') {
      questionType = plainToClass(YesNoQuestionType, data);
    } else {
      throw new Error(`Unknown question typ '${name}'`);
    }

    return questionType;
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/shared/questions/services/question-type-factory.service.ts